// extracted by mini-css-extract-plugin
export var container = "_df-0";
export var containerTopRight = "_df-1";